export default "/static/explore/b946185d86a00c241a56a2bd371c89821aef0275/_next/static/images/header-image-proud-gardener-6ef17a5fa788c074551905721dcba119.png";